export default __webpack_public_path__ + "img/jtc/jtc3_480.jpg";